/**
 * Storefront 2026-10-22 - stun gun age check (snippets/cart-stun-age-check.liquid).
 *
 * Saves each checkbox to its cart attribute the moment it changes:
 * ticked -> 'yes', unticked -> '' (which removes the attribute), so the
 * value survives the cart section being re-rendered and an untick is
 * never left behind. The form submit sends the same values again.
 *
 * Loaded once from snippets/cart-checkout-gate.liquid (outside the
 * empty-cart branch); listeners are delegated from the document because
 * morphed cart markup does not re-run scripts.
 */
(function () {
  if (window.cartStunAgeCheck) return;

  var SELECTOR = 'input[type="checkbox"][data-stun-attribute]';
  var queue = Promise.resolve();

  function save(input) {
    var attributes = {};
    attributes[input.getAttribute('data-stun-attribute')] = input.checked ? 'yes' : '';
    // Serialise the requests so a quick tick/untick lands in order.
    queue = queue
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {
        /* non-fatal; the form submit still sends the attributes */
      });
    return queue;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches(SELECTOR)) save(input);
  });

  // The browser's native "required" check runs before the submit event,
  // so surface the block's inline error as well when it fires.
  document.addEventListener(
    'invalid',
    function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches(SELECTOR)) return;
      input.classList.add('checkout-gate-invalid');
      var block = input.closest('[data-stun-age-check]');
      var error = block && block.querySelector('[data-checkout-gate-error]');
      if (error) error.hidden = false;
    },
    true
  );

  window.cartStunAgeCheck = { save: save };
})();
